let styles = {};

styles.fullWidth = {
    width: '100%'
}

export default styles;


// WEBPACK FOOTER //
// ./styles/contacts.js